import API from './plugins/axios';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const findParent = <T extends Vue>(instance: any, type: any): T | null => {
  if (instance.$parent) {
    if (instance.$parent instanceof type) {
      return instance.$parent;
    } else {
      return findParent(instance.$parent, type);
    }
  } else {
    return null;
  }
};

export const getFileUrl = async (filename: string) => {
  const resp = await API.get(`/api/file/${encodeURIComponent(filename)}`);
  if (resp.status !== 200) return '';
  return resp.data.signedURL;
};

export const isURL = (str: string) => {
  try {
    new URL(str);
    return true;
  } catch {
    const pattern = new RegExp(
      '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$',
      'i'
    ); // fragment locator
    return !!pattern.test(str);
  }
};

export const externalConferenceLinkType = (link: string | undefined) => {
  const zoomLinkPattern = new RegExp(/(([a-z0-9]*)\.)?zoom\.us/i);
  const teamsLinkPattern = new RegExp(/teams\.microsoft\.com/i);
  const meetLinkPattern = new RegExp(/meet\.google\.com\/[a-z-]+/i);
  if (!link) return 'general';
  if (zoomLinkPattern.test(link)) {
    return 'zoom';
  } else if (teamsLinkPattern.test(link)) {
    return 'teams';
  } else if (meetLinkPattern.test(link)) {
    return 'meet';
  } else {
    return 'general';
  }
};
